var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonAttendanceUpdateTimeModal',{attrs:{"attendance":_vm.attendance,"employee":_vm.employee,"hold":_vm.isBusy},on:{"onSubmitClick":_vm.updateAttendance}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }